import type { Principal } from '@cerbos/core';

export type { Principal } from '@cerbos/core';

/**
 * Moved to `@skynet/authz-core`, next to the Cerbos check cache that keys on
 * it, and re-exported here so app code keeps importing the principal helpers
 * from one place.
 *
 * Not the same key the version that used to live here produced: it keys the
 * tenant object rather than its id alone, adds the remaining attributes the
 * policies read, and sorts list-valued ones. The navigation permissions in
 * Redux key on it too and are held in memory only, so the widened key costs
 * them one extra fetch after a deploy and nothing else.
 */
export { getPrincipalKey } from '@skynet/authz-core';

interface JwtPayload extends Record<string, unknown> {
  sub?: string | number;
  roles?: string[];
  status?: number;
  tenant?: {
    id: number;
    name: string;
    isSystem: boolean;
    slug: string;
  };
}

const rolesAnonymous = ['anonymous'];

export const getPrincipal = (jwtPayload?: JwtPayload): Principal => {
  if (jwtPayload?.sub) {
    return {
      id: String(jwtPayload.sub),
      roles: !jwtPayload?.roles?.length ? rolesAnonymous : jwtPayload.roles,
      attr: {
        ...jwtPayload,
        crc: jwtPayload.sub,
      },
    };
  }

  return {
    id: 'ANONYMOUS_USER',
    roles: rolesAnonymous,
    attr: {
      status: 0,
      crc: 0,
    },
  };
};
